const getTooltipContent = (columnName: string): string => {
  switch (columnName) {
    case 'official_local':
      return 'The official local charts are the weekly official singles charts in each country';
    case 'radio':
      return `US & Canada - Mediabase charts 
      Rest of world - Local radio charts`;
    case 'spotify':
      return 'Spotify Top 200 Weekly';
    case 'shazam':
      return 'Shazam Top 200 Weekly';
    // case 'itunes':
    //   return 'Top Downloads';
    default:
      return '';
  }
};

export default getTooltipContent;
